import FormDelete from './FormDelete';
import './formdelete.css';
export default FormDelete;
